import Ajax from '../common/ajax'
import ApiBase from './api-base'

export default {
  ...ApiBase,
  model: 'batch',
  getInfo (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/detail/${id}`)
  },
  close (id) {
    return Ajax.del(`/api/gradeMaster/v1/${this.model}/close/${id}`)
  },
  getAgentList (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/listAgent/${id}`)
  },
  copy (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/copy`, data)
  },
  getPageAgent (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/pageAgent`, data)
  },
  getCopyProgress (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/copyProgress/${id}`)
  },
  getPageOffice (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/pageOffice`, queryParam)
  },
  downloadQrcode (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/downloadQrcode`, queryParam)
  }
}
